export const PAGINATION_PAGE_SIZE = 10;
export const EVENTS_PAGINATION_PAGE_SIZE = 20;
export const PAGINATION_PAGE_SIZE_STEPS = [10, 20, 50];

export const SHOW_MORE_LIMIT_SIZE = 50;
